<template>
  <div class="Header">
    <div class="container">
      <img src="../../../assets/enroll/logo.png" alt="" class="logo" />
      <div class="back" @click="navToHBIC">返回学院官网</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  methods: {
    navToHBIC() {
      window.location.href = "http://www.hebic.cn/";
    },
  },
};
</script>

<style lang="scss" scoped>
.Header {
  height: 90px;
  background: #8f000b;
  .logo {
    width: 250px;
  }
  .container {
    max-width: 1160px;
    margin: 0 auto;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .back {
      width: 180px;
      height: 36px;
      line-height: 36px;
      box-sizing: border-box;
      text-align: center;
      border: 1px solid #ffffff;
      opacity: 1;
      color: #fff;
      cursor: pointer;
      border-radius: 100px;
      font-size: 16px;
    }
  }
}

@media only screen and (max-width: 600px) {
  .Header {
    height: 70px;
    .container {
      padding: 10px;
      .logo {
        width: 200px;
      }
      .back {
        width: 100px;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>
